import { render, staticRenderFns } from "./NewComposerPrompts.vue?vue&type=template&id=05570539&"
import script from "./NewComposerPrompts.vue?vue&type=script&lang=js&"
export * from "./NewComposerPrompts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports